import { render, staticRenderFns } from "./SkinPreviewer.vue?vue&type=template&id=530a07b5&"
import script from "./SkinPreviewer.vue?vue&type=script&lang=ts&"
export * from "./SkinPreviewer.vue?vue&type=script&lang=ts&"
import style0 from "./SkinPreviewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports